module.exports = __webpack_public_path__ + "img/cert_bg_1.dcb18086.jpg";